import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class EnvoiService {

  constructor(private http: HttpClient, private tokenService : TokenService) { }

  recupererLivrables(){
    let httpHeaders = this.tokenService.loadToken();
    let request = `/api/ptl/livrables`;
    return this.http.get(request, {headers: httpHeaders});
  }

  envoyerFiche(idModeration){
    let httpHeaders = this.tokenService.loadToken();
    let request = `/api/envoi?moderation=${idModeration}`;
    return this.http.get(request, {headers:httpHeaders});
  }
}
